export const LEVEL_COEFFICIENT = 0.14;

export function calculateLevel(points = 0) {
  return Math.floor(LEVEL_COEFFICIENT * Math.sqrt(Math.max(0, Number(points) || 0)));
}

export function getPointsForLevel(level = 0) {
  return Math.ceil(Math.pow((Number(level) || 0) / LEVEL_COEFFICIENT, 2));
}

export function getProgressToNextLevel(points = 0, currentLevel = calculateLevel(points)) {
  const safePoints = Math.max(0, Number(points) || 0);
  const safeLevel = Math.max(0, Number(currentLevel) || 0);
  const currentLevelPoints = getPointsForLevel(safeLevel);
  const nextLevelPoints = getPointsForLevel(safeLevel + 1);
  const needed = Math.max(1, nextLevelPoints - currentLevelPoints);
  const current = Math.max(0, safePoints - currentLevelPoints);

  return {
    current,
    needed,
    remaining: Math.max(0, nextLevelPoints - safePoints),
    percentage: Math.max(0, Math.min(100, Math.round((current / needed) * 100))),
  };
}